import React, { createContext, useEffect, useState } from "react";
import './ViewProject.css';
import ViewProjectInfo from "./ViewProjectInfo/ViewProjectInfo";
import ViewProjectMaterials from "./ViewProjectMaterials/ViewProjectMaterials";
import ViewProjectContacts from "./ViewProjectContacts/ViewProjectContacts";
import ViewProjectInduction from "./ViewProjectInduction/ViewProjectInduction";
import ViewProjectAnchorTraining from "./ViewProjectAnchorTraining/ViewProjectAnchorTraining";
import ViewProjectTasks from "./ViewProjectTasks/ViewProjectTasks";

import ViewProjectAddress from "./ViewProjectAddress/ViewProjectAddress";
import ViewProjectTabs from "./ViewProjectTabs/ViewProjectTabs";
import ViewProjectHeader from "./ViewProjectHeader/ViewProjectHeader";
import ProjectAPIs from "../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import ApiResponseHandler from "../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { useNavigate, useParams } from "react-router-dom";
import ViewProjectSkeleton from "./ViewProjectSkeleton/ViewProjectSkeleton";

export const FetchProjectContext = createContext();
export const ProjectDataContext = createContext();

export default function ViewProject(){
    
    const routeParams = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [projectData, setProjectData] = useState(null);
    
    const tabs = [
        { key: "info", label: "Info", component: <ViewProjectInfo /> },
        { key: "address", label: "Address", component: <ViewProjectAddress /> },
        { key: "tasks", label: "Tasks", component: <ViewProjectTasks /> },
        { key: "materials", label: "Materials", component: <ViewProjectMaterials /> },
        { key: "contacts", label: "Contacts", component: <ViewProjectContacts /> },
        { key: "induction", label: "Induction", component: <ViewProjectInduction /> },
        { key: "training", label: "Anchor Training", component: <ViewProjectAnchorTraining /> },
    ];

    const getProjectInformation = (id) => {
        ProjectAPIs.GetProjectTitleInfo(id)
        .then((response) => {
            const data = response.data;

            setProjectData(data);
            setLoading(false);
        })
        .catch((err) => {
            setLoading(false);
            ApiResponseHandler(err.response, navigate);
        });
    }

    useEffect(() => {
        getProjectInformation(routeParams.ProjectID);
    }, [routeParams.ProjectID]);
 

    if(loading) return <ViewProjectSkeleton/>
    
    else{
        return(
            <FetchProjectContext.Provider value={getProjectInformation}>
                <ProjectDataContext.Provider value={projectData}>
                    <div className="project-view-container">
                        <ViewProjectHeader/>
                        <ViewProjectTabs tabs={tabs} />
                    </div>
            </ProjectDataContext.Provider>
            </FetchProjectContext.Provider>
        )
    }

}